<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M22.673,17.009l-2.452-2.453a2.811,2.811,0,0,0-3.979,0l-.5.5A54.366,54.366,0,0,1,8.94,8.245l.5-.5a2.817,2.817,0,0,0,0-3.978L6.983,1.317A2.883,2.883,0,0,0,3,1.317L1.66,2.663a3.981,3.981,0,0,0-.5,4.994A54.174,54.174,0,0,0,16.333,22.833a4.015,4.015,0,0,0,5-.5l1.345-1.346a2.809,2.809,0,0,0,0-3.977Z"
      fill="currentColor"
    />
  </svg>
</template>
